import React from "react";
import classNames from "classnames";
import * as R from "ramda";

import Field from "components/project_form/Field";

import styles from "./Fields.scss";

const Fields = ({ data, fieldsProvided, onChange, page, className, ...props }) => (
  <div className={classNames(className, styles.fieldsContainer)}>
    {R.map(
      (item) => (
        <Field
          key={fieldsProvided ? item.id : item}
          {...(fieldsProvided ? { field: item } : { fieldIdentifier: item })}
          onChange={onChange}
          page={page}
          hideLabel={page?.hide_labels}
          {...props}
        />
      ),
      data,
    )}
  </div>
);

const FieldsContainer = ({ fields = null, fieldIdents = null, ...props }) => {
  const data = fields || fieldIdents;
  if (!data) return null;

  return <Fields data={data} fieldsProvided={!!fields} {...props} />;
};

export default FieldsContainer;
